import {
    SetupDataStore,
    PrequalificationResponseStore,
} from '@servicetitan/financing-workflow-shared';
import { useEffect } from 'react';

export const TransitionToHardApp = ({ onCompleted }: { onCompleted: () => void }) => {
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { prequalificationResponse } = PrequalificationResponseStore.useStore();

    useEffect(() => {
        // Copy prequal id from prequalification response to setup data
        if (prequalificationResponse?.prequalId && setupData) {
            setSetupData({
                ...setupData,
                prequalificationId: prequalificationResponse.prequalId,
            });
            onCompleted();
        }
    }, [prequalificationResponse, onCompleted, setupData, setSetupData]);

    return null;
};
